import {useState, useEffect} from 'react';

type UseMaskedInputProps = { value: string, onChangeText: (text: string) => void, mask: Array<RegExp | string> };

const useMaskedInput = ({value, onChangeText, mask}: UseMaskedInputProps) => {
  const [maskedValue, setMaskedValue] = useState<string>(value);
  const [selection, setSelection] = useState({start: 0, end: 0});

  useEffect(() => {
    applyMask(value);
  }, [value]);

  const applyMask = (input: string) => {
    if (input.length === 0) {
      setMaskedValue('');
      return;
    }

    let masked = '';
    let inputIndex = 0;
    let maskIndex = 0;

    while (inputIndex < input.length && maskIndex < mask.length) {
      if (mask[maskIndex] instanceof RegExp) {
        const regExp = mask[maskIndex] as RegExp;

        if (regExp.test(input[inputIndex])) {
          masked += input[inputIndex];
          inputIndex++;
        }

        maskIndex++;

      } else {
        masked += mask[maskIndex];
        maskIndex++;
      }
    }

    while (maskIndex < mask.length) {
      if (mask[maskIndex] instanceof RegExp) masked += '_';
      else masked += mask[maskIndex];

      maskIndex++;
    }

    setMaskedValue(masked);
    setSelection({start: input.length, end: input.length});
  };

  const handleChangeText = (text: string) => {
    const cleanText = text.replace(/\D/g, '');
    if (cleanText.length > mask.length) return;

    applyMask(cleanText);
    onChangeText(cleanText);
  };

  return {value: maskedValue, onChangeText: handleChangeText, selection};
};

export default useMaskedInput;
